import React, { useState } from 'react';
import "../Home/craft.css";
import Background from "../../assets/images/Craft/background.jpg";
import '@fortawesome/fontawesome-free/css/all.min.css';
import Bg from "../../assets/images/background/banner.jpg";
import { Link } from 'react-router-dom';


//import background services images
import img1 from "../../assets/images/Craft/website.jpg";
import img2 from "../../assets/images/Craft/brand.jpg";
import img3 from "../../assets/images/Craft/mobile.jpg";
import img4 from "../../assets/images/Craft/it-infrastructure-management.jpg";
import img5 from "../../assets/images/Craft/it-consulting-and-advisory.jpg";
import img6 from "../../assets/images/Craft/graphics-design.jpg";
import img7 from "../../assets/images/Craft/erp-crm-solution.jpg";
import img8 from "../../assets/images/Craft/email-services.jpg";
import img9 from "../../assets/images/Craft/wordpress-woocommerce.jpg";
import img10 from "../../assets/images/Craft/domain-hosting.jpg";
import img11 from "../../assets/images/Craft/digital-transformation.jpg";
import img12 from "../../assets/images/Craft/cybersecurity.jpg";
import img13 from "../../assets/images/Craft/cloud-server.jpg";
import img14 from "../../assets/images/Craft/cloud-computing.jpg";
import img15 from "../../assets/images/Craft/business-process-automation.jpg";
import img16 from "../../assets/images/Craft/odoo.jpg";
import img17 from "../../assets/images/Craft/software.jpg";

import SEO from "../seo";

const Craft = () => {

    // service data list (keeps structure same)
   const services = [
        {
            icon: '<i class="fas fa-robot"></i>',
            heading: "Business Process Automation",
            text: "We help businesses automate workflows and operations using business process automation software to improve efficiency, reduce manual errors, and save time. Ideal for finance, HR, sales, and operational processes.",
            image: img15,
            route: '/services/business-process-automation',

        },
        {
            icon: '<i class="fas fa-cloud"></i>',
            heading: "Cloud Computing Services",
            text: "In the ever-evolving digital landscape, Horizon Webinfo Pvt. Ltd. has been a trailblazer in delivering transformative Cloud",
            image: img14,
            route: '/services/cloud-computing-services',

        },
        {
            icon: '<i class="fas fa-cloud-upload"></i>',
            heading: "Cloud Server Solution",
            text: "Our cloud server solutions in India offer secure, scalable, and high-performance hosting for websites, applications, and ERP systems. Ensure data security, uptime, and remote accessibility with managed cloud services.",
            image: img13,
            route: '/services/cloud-server-solution',

        },

        {
            icon: '<i class="fas fa-code"></i>',
            heading: "Custom Software Development",
            text: "We are a trusted custom software development company in India, building secure and scalable applications tailored to your business growth.",
            image: img17,

        },
        {
            icon: '<i class="fas fa-user-secret"></i>',
            heading: "Cybersecurity Solutions",
            text: "In the dynamic realm of digital landscapes, cybersecurity is not just a necessity; it’s a cornerstone of business resilience. Horizon Webinfo Pvt. Ltd. has been…",
            image: img12,
            route: '/services/cybersecurity-solutions-ahmedabad',

        },
        {
            icon: '<i class="fas fa-object-group"></i>',
            heading: "Digital Transformation Consulting",
            text: "Embark on a transformative journey with our unparalleled Digital Transformation Consulting services. In a rapidly evolving digital",
            image: img11,
            route: '/services/digital-transformation-consulting',

        },
        {
            icon: '<i class="fas fa-rocket"></i>',
            heading: "Domain & Hosting",
            text: "Get reliable domain registration and web hosting services in India with high uptime, security, and technical support. We provide end-to-end hosting solutions for businesses of all sizes.",
            image: img10,
            route: '/services/domain-hosting',

        },
        {
            icon: '<i class="fas fa-store"></i>',
            heading: "Ecommerce Development",
            text: "We deliver e-commerce website development services with secure payment gateway integration, inventory management, and mobile-friendly design to boost online sales and customer engagement.",
            image: img9,
            route: '/services/ecommerce-development-ahmedabad',

        },
        {
            icon: '<i class="fas fa-envelope"></i>',
            heading: "Email Services",
            text: "Professional business email hosting services with your domain name, advanced security, spam protection, and anywhere access. Build credibility and streamline business communication.",
            image: img8,
            route: '/services/email-services',

        },
        {
            icon: '<i class="fas fa-network-wired"></i>',
            heading: "ERP/CRM Solution",
            text: "Our ERP and CRM solutions help businesses manage leads, customers, operations, billing, and reporting efficiently, reducing manual work and errors.",
            image: img7,
            route: '/services/erp-crm-solution',

        },
        {
            icon: '<i class="fas fa-globe"></i>',
            heading: "IT Consulting and Advisory",
            text: "Horizon Webinfo Pvt. Ltd. stands as a beacon of expertise in IT Consulting and Advisory services...",
            image: img5,
            route: '/services/it-consulting-and-advisory',

        },
        {
            icon: '<i class="fas fa-cogs"></i> ',
            heading: "IT Infrastructure Management",
            text: "At Horizon Webinfo Pvt. Ltd. we take pride in our legacy of delivering top-notch IT Infrastructure.",
            image: img4,
            route: '/services/it-infrastructure-management',

        },
        {
            icon: '<i class="fas fa-mobile-alt"></i>',
            heading: "Mobile App Development",
            text: "We develop Android and iOS mobile applications for business, internal operations, and customer engagement with a smooth and user-friendly experience.",
            image: img3,
            route: '/services/mobile-app-development',

        },
        {
            icon: '<i class="fas fa-layer-group"></i>',
            heading: "Odoo ERP Development & Customization",
            text: "Our experienced Odoo ERP developers help Indian businesses automate processes like Sales, Accounting, Inventory, HR, Manufacturing, CRM, and Purchase—all in one integrated system.",
            image: img16,
            route: '/odoo',

        },


        {
            icon: '<i class="fas fa-laptop-code"></i>',
            heading: "Website Design & Development",
            text: "We build professional, mobile-friendly, and SEO-optimized websites that create trust and generate enquiries. From corporate websites to dynamic portals and e-commerce platforms, we handle it all.",
            image: img1,
            route: '/services/website-development-in-ahmedabad',
        },


        // {
        //     icon: '<i class="fas fa-chalkboard"></i>',
        //     heading: "Product Branding",
        //     text: "Collaborate Consulting exists to find the place where being seeming disparate interests meet.",
        //     image: img2,
        //     route: '/services/product-branding',

        // },

        // {
        //     icon: '<i class="fas fa-magic"></i>',
        //     heading: "Graphics Design",
        //     text: "Elevate your brand with our bespoke graphic design solutions. From captivating logos to stunning visuals, we bring your vision to life.",
        //     image: img6,
        //     route: '/services/graphics-design',

        // },

    ];


    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ]; 

    return (
        <div>
               <SEO
                title="Services"
                description="Crafting Your Digital Presence Explore our specialized IT services engineered for your success. From robust software development to seamless integrations, we tailor innovation to elevate your business outcomes. Website Development Crafting immersive digital experiences through expert website development. Elevate your online presence with our tailored solutions and innovative designs. Website Development Crafting immersive digital experiences [&hellip;]"
                canonical="https://www.hwplindia.com/services/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2024/01/erp-crm-development-company-banner-img.png"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Bg})` }}
            >
                <div className="auto-container">
                    <h2>Services</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Services</li>
                    </ul>
                </div>
            </section>

            <section
                className="services-one"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    {/* Sec Title */}
                    <div className="sec-title centered">
                        <h2 className="sec-title_heading">Our Core Services</h2>
                        <div className="sec-title_text sec-sub-ma">
                            Explore our specialized IT services engineered for your success. <br />
                            From robust software development to seamless integrations, we tailor <br />
                            innovation to elevate your business outcomes.
                        </div>
                    </div>

                    <div className="row clearfix">
                        {services.map((service, index) => (
                            <div key={index} className="service-block_one col-lg-4 col-md-6 col-sm-12">
                                <div
                                    className={`service-block_one-inner wow fadeInUp`}
                                    data-wow-delay="0ms"
                                    data-wow-duration="1500ms"
                                >
                                    <div
                                        className="service-block_one-icon"
                                        dangerouslySetInnerHTML={{ __html: service.icon }}
                                    />
                                    <h5 className="service-block_one-heading">{service.heading}</h5>
                                    <div className="service-block_one-text">{service.text}</div>

                                    <div
                                        className="service-block_one-overlay"
                                        style={{
                                            backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${service.image})`
                                        }}
                                    >

                                        <div className="service-block_one-overlay-inner">
                                            <div className="upper-box">
                                                <div
                                                    className="service-block_one-icon-two"
                                                    dangerouslySetInnerHTML={{ __html: service.icon }}
                                                />
                                                <h5 className="service-block_one-heading-two">
                                                    <Link to={service.route}>{service.heading}</Link>
                                                </h5>
                                            </div>
                                            <div className="service-block_one-text-two">{service.text}</div>
                                            {/* Button Box */}
                                            <div className="service-block_one-button">
                                                <Link className="btn-style-two theme-btn btn-item" to={service.route}>
                                                    <div className="btn-wrap">
                                                        <span className="text-one">
                                                            Read more <i className="fa-solid fa-arrow-right fa-fw" />
                                                        </span>
                                                        <span className="text-two">
                                                            Read more <i className="fa-solid fa-arrow-right fa-fw" />
                                                        </span>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>
        </div>
    );
};

export default Craft;
